// Mocked data for the Builder-Promo UI (UI-only, no backend calls).

export const creatingStages = [
    {
        eyebrow: 'STAGE 1',
        title: 'Understanding your business',
        percent: 30,
        active: 0,
    },
    {
        eyebrow: 'STAGE 2',
        title: 'Choosing your website direction',
        percent: 60,
        active: 1,
    },
    {
        eyebrow: 'STAGE 3',
        title: 'Writing your homepage copy',
        percent: 60,
        active: 2,
    },
    {
        eyebrow: 'STAGE 4',
        title: 'Designing your first page',
        percent: 80,
        active: 3,
    },
    {
        eyebrow: 'STAGE 5',
        title: 'Finalizing your preview',
        percent: 95,
        active: 5,
    },
];

export const checkoutSteps = ['plan', 'payment', 'business', 'build', 'success'];

export const updateStages = [
    { label: 'Applying your feedback', percent: 33 },
    { label: 'Refining visual style', percent: 66 },
    { label: 'Finalizing new preview', percent: 100 },
];

export const buildSteps = [
    { percent: 25 },
    { percent: 55 },
    { percent: 80 },
    { percent: 100 },
];
